import { useEffect, useState } from "react";

/** Breakpoint `sm` do Tailwind: a partir daqui o aviso vai para o canto inferior direito. */
const CONSULTA_SM = "(min-width: 640px)";

/**
 * A tela é larga (>= 640 px)? Os dois avisos (shadcn e sonner) usam o mesmo corte: no
 * computador ficam embaixo à direita; no celular, no topo, logo abaixo do cabeçalho de 64 px.
 * Sem `matchMedia` (ambiente antigo ou de teste) conta como estreito.
 */
export function useLarguraSm(): boolean {
  const [largo, setLargo] = useState(
    () =>
      typeof window !== "undefined" &&
      typeof window.matchMedia === "function" &&
      window.matchMedia(CONSULTA_SM).matches
  );
  useEffect(() => {
    if (typeof window.matchMedia !== "function") return;
    const mql = window.matchMedia(CONSULTA_SM);
    const aoMudar = () => setLargo(mql.matches);
    mql.addEventListener?.("change", aoMudar);
    return () => mql.removeEventListener?.("change", aoMudar);
  }, []);
  return largo;
}
